/* ============================================================
   RILASSI Product Page Controller
   - Syncs phrase / color / size selections → variant ID + price + image
   - Updates volume tier display based on quantity
   - Size guide modal open/close
   - Vanilla JS, no deps
   ============================================================ */

(function () {
  'use strict';

  const root = document.querySelector('[data-rl-product]');
  if (!root) return;

  const productData = JSON.parse(root.querySelector('[data-rl-product-json]').textContent);
  const variants = productData.variants || [];
  const variantImages = productData.variant_images || {};
  const optionsCount = productData.options ? productData.options.length : 0;

  const form = root.querySelector('[data-rl-form]');
  const variantInput = root.querySelector('[data-rl-variant-id]');
  const priceEl = root.querySelector('[data-rl-price]');
  const submitBtn = root.querySelector('[data-rl-submit]');
  const mainImage = root.querySelector('[data-rl-main-image]');
  const qtyInput = root.querySelector('[data-rl-qty-input]');
  const qtyMinus = root.querySelector('[data-rl-qty-minus]');
  const qtyPlus = root.querySelector('[data-rl-qty-plus]');
  const tiersRows = root.querySelectorAll('[data-rl-tier]');
  const contactCta = root.querySelector('[data-rl-contact-cta]');

  // Current selections — find from initial selected variant
  const selected = [null, null, null];
  if (productData.selected_variant) {
    if (productData.selected_variant.option1) selected[0] = productData.selected_variant.option1;
    if (productData.selected_variant.option2) selected[1] = productData.selected_variant.option2;
    if (productData.selected_variant.option3) selected[2] = productData.selected_variant.option3;
  }

  function findVariant() {
    return variants.find(function (v) {
      for (let i = 0; i < optionsCount; i++) {
        const optKey = 'option' + (i + 1);
        if (selected[i] !== null && v[optKey] !== selected[i]) return false;
      }
      return true;
    });
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return 'CHF ' + amount;
  }

  function updateUI() {
    const variant = findVariant();
    if (!variant) {
      if (submitBtn) {
        submitBtn.textContent = 'Indisponible';
        submitBtn.disabled = true;
      }
      return;
    }
    // Update hidden variant ID
    if (variantInput) variantInput.value = variant.id;
    // Update price
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    // Update CTA
    if (submitBtn) {
      if (variant.available) {
        submitBtn.textContent = 'Ajouter au panier';
        submitBtn.disabled = false;
      } else {
        submitBtn.textContent = 'Épuisé';
        submitBtn.disabled = true;
      }
    }
    // Update image from the alt-text-derived variant_images map
    if (mainImage) {
      const url = variantImages[variant.id];
      if (url) {
        mainImage.src = url;
        mainImage.srcset = '';
      }
    }
    // Update URL state
    try {
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    } catch (e) {}
  }

  // ── Phrase selector ─────────────────────────────────────
  root.querySelectorAll('[data-rl-phrase]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const fieldset = btn.closest('[data-option-index]');
      const idx = parseInt(fieldset.dataset.optionIndex, 10);
      selected[idx] = btn.dataset.value;
      fieldset.querySelectorAll('[data-rl-phrase]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      const label = fieldset.querySelector('[data-rl-phrase-value]');
      if (label) label.textContent = btn.dataset.value;
      updateUI();
    });
  });

  // ── Color swatch ────────────────────────────────────────
  root.querySelectorAll('[data-rl-color]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const fieldset = btn.closest('[data-option-index]');
      const idx = parseInt(fieldset.dataset.optionIndex, 10);
      selected[idx] = btn.dataset.value;
      fieldset.querySelectorAll('[data-rl-color]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      const label = fieldset.querySelector('[data-rl-color-value]');
      if (label) label.textContent = btn.dataset.value;
      updateUI();
    });
  });

  // ── Size picker ─────────────────────────────────────────
  root.querySelectorAll('[data-rl-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const fieldset = btn.closest('[data-option-index]');
      const idx = parseInt(fieldset.dataset.optionIndex, 10);
      selected[idx] = btn.dataset.value;
      fieldset.querySelectorAll('[data-rl-size]').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      const label = fieldset.querySelector('[data-rl-size-value]');
      if (label) label.textContent = btn.dataset.value;
      updateUI();
    });
  });

  // ── Quantity ────────────────────────────────────────────
  function updateTierHighlight() {
    if (!qtyInput || !tiersRows.length) return;
    const q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    tiersRows.forEach(function (row) {
      const min = parseInt(row.dataset.min, 10);
      const max = parseInt(row.dataset.max, 10);
      if (q >= min && q <= max) row.classList.add('is-current');
      else row.classList.remove('is-current');
    });
    if (contactCta) {
      if (q >= 25) contactCta.removeAttribute('hidden');
      else contactCta.setAttribute('hidden', '');
    }
  }
  if (qtyMinus) {
    qtyMinus.addEventListener('click', function () {
      const v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = v;
      updateTierHighlight();
    });
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', function () {
      const v = (parseInt(qtyInput.value, 10) || 1) + 1;
      qtyInput.value = v;
      updateTierHighlight();
    });
  }
  if (qtyInput) qtyInput.addEventListener('input', updateTierHighlight);
  updateTierHighlight();

  // ── Thumbnail click → swap main image ───────────────────
  const thumbs = root.querySelectorAll('[data-rl-thumb]');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      const src = t.dataset.src;
      if (mainImage && src) {
        mainImage.src = src;
        mainImage.srcset = '';
      }
      thumbs.forEach(function (b) { b.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  // ── Size guide modal ────────────────────────────────────
  const modal = document.querySelector('[data-rl-size-guide]');
  const openBtns = document.querySelectorAll('[data-rl-open-size-guide]');
  const closeBtns = modal ? modal.querySelectorAll('[data-rl-modal-close]') : [];
  function openModal() {
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.body.classList.add('rl-modal-open');
  }
  function closeModal() {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('rl-modal-open');
  }
  openBtns.forEach(function (b) { b.addEventListener('click', openModal); });
  closeBtns.forEach(function (b) { b.addEventListener('click', closeModal); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // Initial sync
  updateUI();
})();
